import { Player, Position, Tournament } from '@/views/interfaces/entities.ts';
import { APITournament, APIPosition, defaultPlayer, APIPlayer } from '@/views/interfaces/apiEntities';


export const APITournamentsToTournaments = (apiTournaments: APITournament[]): Tournament[] => {
    return apiTournaments.map( (apiTournament) => APITournamentToTournament(apiTournament) );
}


export const APITournamentToTournament = (apiTournament: APITournament): Tournament => {
    const { position_set, total_rounds, current_round, status, champion } = apiTournament;

    const tournament: Tournament = {
      id: apiTournament.id,
      name: apiTournament.name,
      size: apiTournament.size,
      tournamentType: apiTournament.tournament_type,
      status,
      currentRound: apiTournament.current_round,
      totalRounds: apiTournament.total_rounds,
      matchTime: apiTournament.match_time,
      positions: APIpositionsToPositions(position_set, total_rounds, current_round, status),
      endMatch: apiTournament.match_ends,
      views: apiTournament.views,
      champion: champion ? APIpositionsToPositions([champion], total_rounds, current_round, status)[0] : undefined,
    };

    return tournament;
};


export const APIpositionsToPositions = (APIPositions: APIPosition[], totalRounds: number, currentRound: number, status: string): Position[] => {
  const positions: Position[] = [];

  APIPositions.forEach((APIPosition) => {
    const { id, depth, votes, bracket_index, left_position, right_position, next_position } = APIPosition;
    let { player } = APIPosition;
    if (player == null)  player = defaultPlayer;
    positions.push({
      id,
      posIndex: bracket_index,
      player: {
        id: player.id,
        avatar: player.avatar,
        name: player.name,
      },
      depth,
      votes,
      nextPos: next_position,
      leftPos: left_position,
      rightPos: right_position,
      disabled: ((status === 'ended') || (totalRounds + 1 - currentRound !==  depth) ), // current round by depth condition
    });
  });
  return positions;
};

  // tournamentType: string | undefined;
  // positions: Position[];
  // endMatch: number;

export const tournamentToAPITournament = (tournament: Tournament): APITournament => {
  const { id, name, size, tournamentType, status, totalRounds, currentRound, matchTime, positions, views, champion } = tournament;
  
  const apiTournament: APITournament = {
    id,
    name,
    size,
    tournament_type: tournamentType || 'elimination',
    status,
    current_round: currentRound,
    total_rounds: totalRounds,
    match_time: matchTime,
    position_set: positionsToAPIPositions(positions),
    match_ends: tournament.endMatch,
    views,
    champion: champion? positionsToAPIPositions([champion])[0] : undefined ,
  };

  return apiTournament;
}


export const positionsToAPIPositions = (positions: Position[]): APIPosition[] => {
  const apiPositions: APIPosition[] = [];

  positions.forEach((position) => {
      const { id, posIndex, depth, votes, leftPos, rightPos, player } = position;

      apiPositions.push({
        id,
        bracket_index: posIndex,
        depth,
        votes,
        player: playerToAPIPlayer(player),
        left_position: leftPos,
        right_position: rightPos,
      } as APIPosition);
  });

  return apiPositions;
};


const playerToAPIPlayer = (player : Player | undefined): APIPlayer | undefined => {
  if(!player) return undefined;
  return player as APIPlayer;

}